module.exports = "https://static.wanderu.com/static/media/ca.dc41a827.svg";